import {useState} from "react";

import { BasicButton, ThriveIcon, IconLibrary, LoadingSpinner } from "thrive-components";
import { useObservable } from 'thrive-observable-react';

//component
import ModalWrapper from '@/components/modals/ModalWrapper.tsx';
import CsvDropzone from "./CsvDropZone.tsx";
import DiffResults from "./DiffResults.tsx";


// models
import {UserGroupSyncService} from "./UserGroupSync.service.ts";
import { UserGroupSyncModel } from './models/UserGroupSyncModal.model.ts'

//styling
import "../../../css/global/Modals/remove-passkeys-modal.scss";


const UserGroupSyncModal = ({showModal, hideModal, UGSS} : {showModal: boolean, hideModal: () => void, UGSS: UserGroupSyncService}) => {

    // initialize model and inject UGSS
    const [UGSM] = useState<UserGroupSyncModel>(new UserGroupSyncModel(UGSS));

    // observables for react state updates
    const file = useObservable<File | undefined>(UGSM.file)
    const diffResults = useObservable<any>(UGSM.diffResults)
    const syncId = useObservable<string>(UGSM.syncId)
    const errorString = useObservable<string>(UGSM.errorString);

    if (!showModal){
        return <></>
    }
    return (
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="user-group-sync-modal"
        >
            <>
                <div className={'user-group-sync-modal-contents'}>
                    <h1>Sync User Groups</h1>
                    {UGSM.showDropzone() && <>
                        <div>
                            <p>Upload a CSV file containing a list of all the users and  their group assignments.
                                If you have not already downloaded the template
                                <a href={'/api/user-group-sync/template'} target={'_blank'} style={{marginLeft:'6px'}}>click here to get one</a>
                            </p>
                        </div>
                        <CsvDropzone
                            file={file}
                            onFileAccepted={(file: File) => {
                                UGSM.setFile(file);
                                UGSM.setErrorString('');
                            }}
                            onError={(msg: any) => UGSM.setErrorString(msg)}
                        />
                    {!!errorString && <p className={'error-string'}>{errorString}</p>}
                    </>}
                    {UGSM.showProcessing() && <div className="user-group-sync-loading-wrapper">
                        <p className={'loading-text'}> Calculating Changes </p>
                        <LoadingSpinner size={16} />
                    </div>}
                    {UGSM.showResult() && <DiffResults
                        diff={diffResults}
                    />}
                </div>
                <div className={'user-group-sync-modal-footer'}>
                    <div className={'left'}>
                        {syncId && <BasicButton
                            content={
                                <div className="user-group-sync-icon-button-wrapper">
                                    <ThriveIcon
                                        iconName={IconLibrary.DOWNLOAD}
                                        sizeInPx={'14'}
                                        color={"var(--thriveGreyDark"}
                                    />
                                    <span>Download Diff</span>
                                </div>
                            }
                            ariaLabel={'Download This Diff'}
                            isLink={true}
                            linkUrl={`/api/user-group-sync/${syncId}/diff`}
                            openInNewTab={true}
                        />}
                    </div>
                    <div className={'right'}>
                        <BasicButton
                            content={'Close'}
                            ariaLabel={'Close'}
                            onButtonClick={hideModal}
                        />
                        {UGSM.showDropzone() && <BasicButton
                            isClassicThriveStyle
                            content={'Upload File'}
                            isDisabled={!file}
                            onButtonClick={UGSM.handleCreateDif}
                            ariaLabel={'Upload'}
                        />}
                        {!UGSM.showDropzone() && !!diffResults &&
                            <BasicButton
                                className={'success-button'}
                                content={
                                    <div className="user-group-sync-icon-button-wrapper">
                                        <span>Complete Group Sync </span>
                                        <ThriveIcon
                                            iconName={IconLibrary.CIRCLE_CHECK}
                                            sizeInPx={'14'}
                                            color={"var(--thriveGreen)"}
                                        />
                                    </div>
                                }
                                isDisabled={!diffResults}
                                ariaLabel={'Complete'}
                                onButtonClick={async() => {
                                    await UGSM.handleCompleteSync();
                                    hideModal();
                                }}
                            />
                        }
                    </div>

                </div>

            </>
        </ModalWrapper>
    );  
}

export default UserGroupSyncModal;